const openingFunc = () => {
  const elem = document.getElementById('js-opening-mask');
  if (elem) {
    const msM = 500;
    elem.style.transition = 'opacity ' + msM + 'ms';
    const loadingOpacity = () => {
      //透過させる関数を定義
      elem.style.opacity = '0';
    };
    const loadingDisplay = () => {
      //非表示にする関数を定義
      elem.style.display = 'none';
    };
    setTimeout(loadingOpacity, 400); //読み込み後、0.4秒後に透過を開始
    setTimeout(loadingDisplay, 400 + msM); //読み込み後、２秒後に非表示
  }
};

export { openingFunc };
